"use client"

import { useState } from "react"
import { FaEdit, FaTrash, FaEye } from "react-icons/fa"
import { useObservations } from "../context/ObservationContext"
import ImageViewer from "./ImageViewer"
import "./ObservationItem.css"

const ObservationItem = ({ observation, onEdit }) => {
  const [showImageViewer, setShowImageViewer] = useState(false)
  const { deleteObservation } = useObservations()

  const handleDelete = () => {
    if (window.confirm("Tem certeza que deseja excluir esta observação?")) {
      deleteObservation(observation.id)
    }
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    })
  }

  return (
    <div className="observation-item">
      {observation.image && (
        <div className="observation-image-container">
          <img
            src={observation.image || "/placeholder.svg"}
            alt={observation.title}
            className="observation-image"
            onClick={() => setShowImageViewer(true)}
          />
          <button className="view-image-button" onClick={() => setShowImageViewer(true)}>
            <FaEye />
          </button>
        </div>
      )}

      <div className="observation-content">
        <h3 className="observation-title">{observation.title}</h3>

        {observation.description && <p className="observation-description">{observation.description}</p>}

        <div className="observation-date">
          <small>Criado em: {formatDate(observation.createdAt)}</small>
        </div>
      </div>

      <div className="observation-actions">
        <button className="btn-icon delete" onClick={handleDelete}>
          <FaTrash />
        </button>
      </div>

      {showImageViewer && observation.image && (
      <div className="img-full" onClick={() => setShowImageViewer(false)}>
        
        <img src={observation.image} alt=" full size"/>
     </div> )}
    </div>
  )
}

export default ObservationItem

